/**
 * Triggers a browser "save as" for an in-memory Blob by creating a temporary
 * object URL and clicking a hidden anchor. Used for files fetched via the
 * authenticated API client (which returns bytes rather than a navigable URL).
 */
export const saveBlob = (blob: Blob, filename: string): void => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
};
